"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Workflow = void 0;
class Workflow {
    constructor(data) {
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        Object.assign(this, input);
        return this;
    }
}
exports.Workflow = Workflow;
